/** The list's groups, in the order they are shown. */
export var TripGroupKind;
(function (TripGroupKind) {
    /** Soonest start first, a trip in progress included. Filled once trips have dates (phase 12). */
    TripGroupKind["UPCOMING"] = "UPCOMING";
    /** Newest first. */
    TripGroupKind["NO_DATES_YET"] = "NO_DATES_YET";
    /** Most recent end first. Filled once trips have dates (phase 12). */
    TripGroupKind["PAST"] = "PAST";
})(TripGroupKind || (TripGroupKind = {}));
/**
 * Groups the owner's trips as drawn (Tal, phase 01). Trips have no dates until phase 12, so every trip is in
 * "No dates yet"; phase 12 adds the Upcoming and Past rules together with the owner's local "today".
 */
export class TripListGrouping {
    groupTrips(trips) {
        const tripsWithoutDates = [...trips].sort((first, second) => this.compareNewestFirst(first, second));
        const groups = [{ kind: TripGroupKind.NO_DATES_YET, trips: tripsWithoutDates }];
        return groups.filter(group => group.trips.length > 0);
    }
    compareNewestFirst(first, second) {
        const timeDifference = second.createdAt.get().getTime() - first.createdAt.get().getTime();
        return timeDifference === 0 ? second.getId().localeCompare(first.getId()) : timeDifference;
    }
}
//# sourceMappingURL=TripListGrouping.js.map